/**
 * The teacher's phone Region schedule: the region's next two weeks first,
 * then a block at a time as the teacher asks for more. Cached apart from the
 * desktop schedule's plain lists.
 */
import type { WorkshopChip } from '../primitives';
import { useWorkshopBlocks } from '../primitives/use-workshop-blocks';

import { fetchRegionChips } from './use-region-workshops';

export function useRegionWorkshopsAhead(regionId?: string) {
  return useWorkshopBlocks<WorkshopChip>({
    keyParts: ['me', 'region-workshops-ahead', regionId],
    fetchBlock: ({ from, to }) => fetchRegionChips(regionId as string, from, to),
    enabled: Boolean(regionId),
  });
}
